import {
  PortfolioAnalysisPage,
  PortfolioDetailPage,
  PortfolioListPage,
  PortfolioTargetPage,
} from 'apps/robo-advisory/components/Portfolio';
import {
  StagPortfolioDetailPage,
  StagPortfolioFormPage,
  StagPortfolioListPage,
} from 'apps/robo-advisory/components/stag-portfolios/pages';
import {
  SurveyReportDetailPage,
  SurveyReportListPage,
} from 'apps/robo-advisory/components/SurveyReports/pages';
import { SURVEY_REPORT_TYPE } from 'apps/robo-advisory/components/SurveyReports/constants';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// Old links point at /hub/... (Financial Tools), /investment/portfolios/...
// and /admin/stag-portfolios/...
// Send them to the same page under /robo-advisory, keeping the query string.
const LegacyRedirect = ({ from, to }) => {
  const { pathname, search } = useLocation();
  return <Navigate to={pathname.replace(from, to) + search} replace />;
};

const LegacyFHCReportRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/robo-advisory/survey-reports/${id}`} replace />;
};

const legacyPortfolioRedirect = (
  <LegacyRedirect from="/investment/portfolios" to="/robo-advisory/portfolios" />
);

const roboAdvisoryRoutes = [
  { path: '/robo-advisory/portfolios', element: <PortfolioListPage /> },
  {
    path: '/robo-advisory/portfolios/:user_id',
    element: <PortfolioDetailPage />,
  },
  {
    path: '/robo-advisory/portfolios/:user_id/analysis',
    element: <PortfolioAnalysisPage />,
  },
  {
    path: '/robo-advisory/portfolios/:user_id/target',
    element: <PortfolioTargetPage />,
  },
  {
    path: '/robo-advisory/stag-portfolios',
    element: <StagPortfolioListPage />,
  },
  {
    path: '/robo-advisory/stag-portfolios/create',
    element: <StagPortfolioFormPage />,
  },
  {
    path: '/robo-advisory/stag-portfolios/:id',
    element: <StagPortfolioDetailPage />,
  },
  {
    path: '/robo-advisory/stag-portfolios/:id/edit',
    element: <StagPortfolioFormPage />,
  },
  { path: '/robo-advisory/survey-reports', element: <SurveyReportListPage /> },
  {
    path: '/robo-advisory/survey-reports/:id',
    element: <SurveyReportDetailPage />,
  },

  // Legacy URLs
  { path: '/investment/portfolios/*', element: legacyPortfolioRedirect },
  {
    path: '/admin/stag-portfolios/*',
    element: <LegacyRedirect from="/admin" to="/robo-advisory" />,
  },
  {
    path: '/hub',
    element: <Navigate to="/robo-advisory/survey-reports" replace />,
  },
  {
    path: '/hub/survey-reports/*',
    element: <LegacyRedirect from="/hub" to="/robo-advisory" />,
  },
  // /hub/fhc-reports links land on the health check (1002) filter.
  {
    path: '/hub/fhc-reports',
    element: (
      <Navigate
        to={`/robo-advisory/survey-reports?type=${SURVEY_REPORT_TYPE.INVESTMENT_HEALTHCHECK}`}
        replace
      />
    ),
  },
  { path: '/hub/fhc-reports/:id', element: <LegacyFHCReportRedirect /> },
];

export default roboAdvisoryRoutes;
